import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsAllPlanWorks: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_ALL_PLAN_WORKS].GET_REGULATIONS_ALL_PLAN_WORKS,
	},
}